const getOrdersState = state => state.get('orders') || state.orders;

const getOrderById = (state, { orderId, id }) =>
  getOrdersState(state).ordersById[orderId || id] || null;

export const ordersSelectors = {
  orderById: getOrderById
};
